import adminRoutes from './admin'
import apiRoutes from './api'
import privateRoutes from './private'
import publicRoutes from './public'
import { flattenObject, type Route } from './utils'

const routes = {
	api: apiRoutes,
	public: publicRoutes,
	private: privateRoutes,
	admin: adminRoutes,
	external: {
		relative: (relative: string) => {
			const IS_PROD = process.env.NODE_ENV === 'production'
			const pathname = relative.startsWith('/')
				? relative.substring(1)
				: relative

			return IS_PROD
				? `https://www.sapienstone.com/${pathname}`
				: `http://localhost:3005/${pathname}`
		},
		social: {
			linkedin: 'https://www.linkedin.com/company/sapienstone-official-page/',
			facebook: 'https://www.facebook.com/sapienstone/',
			instagram: 'https://www.instagram.com/sapienstone',
			youtube: 'https://www.youtube.com/channel/UCM_ButpUEimtoMmx7Jb_uew',
			pinterest: 'https://www.pinterest.it/sapienstone',
		},
	},
}

const filterRoutes = (condition: (route: Route) => boolean) => {
	const flattenedRoutes = flattenObject(routes)

	return Object.values(flattenedRoutes)
		.filter((r) => 'isLocalized' in r || 'isProtected' in r)
		.filter(condition)
}

export const protectedRoutes = filterRoutes((route) => route.isProtected)
export const localizedRoutes = filterRoutes((route) => route.isLocalized)

export default routes
